// Configure Material-UI
import { ThemeProvider } from '@mui/material/styles';
import '@fontsource/cormorant-garamond';
import '@fontsource/source-sans-pro';
import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { promiseMiddleware } from 'cooldux';
import logger from 'redux-logger';
import { SWRConfig } from 'swr';

import { apiFetch } from './lib/fetch';
import theme from './theme';
import reducers from './state';

import ProtectedRoute from './components/protected-route';

import Home from './pages/home';

import Dashboard from './pages/dashboard';
import Login from './pages/login';
import NewClient from './pages/client-new';
import ClientEdit from './pages/client-edit';
import ClientAssetsYear from './pages/client-assets-year';
import ClientIncomeYear from './pages/client-income-year';
import ClientRetirementPlan from './pages/client-retirement-plan';
import DefaultRetirementPlan from './pages/client-default-retirement-plan';
import ClientReports from './pages/client-reports';
import Settings from './pages/settings';
import RegStep2 from './pages/reg-step2';
import Reports from './pages/reports';
import Demo from './pages/demo';
import './index.css';

const middlewares = [thunkMiddleware, promiseMiddleware];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);
}

const store = createStore(reducers, applyMiddleware(...middlewares));

render(
  <Provider store={store}>
    <SWRConfig
      value={{
        refreshInterval: 0,
        fetcher: apiFetch,
      }}
    >
      <ThemeProvider theme={theme}>
        <Router>
          <Switch>
            <Route exact path="/" component={Home} />
            <ProtectedRoute path="/dashboard" component={Dashboard} />
            <ProtectedRoute exact path="/clients/new" component={NewClient} />
            <ProtectedRoute exact path="/clients/:id" component={ClientEdit} />
            <ProtectedRoute exact path="/clients/:id/assets_year" component={ClientAssetsYear} />
            <ProtectedRoute exact path="/clients/:id/income_year" component={ClientIncomeYear} />
            <ProtectedRoute exact path="/clients/:id/income_plan" component={ClientRetirementPlan} />
            <ProtectedRoute exact path="/clients/:id/default_plan" component={DefaultRetirementPlan} />
            <ProtectedRoute exact path="/clients/:id/reports" component={ClientReports} />
            <ProtectedRoute path="/reports" component={Reports} />
            <ProtectedRoute path="/settings" component={Settings} />
            <ProtectedRoute path="/reg/step2" component={RegStep2} />
            <ProtectedRoute path="/demo" component={Demo} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/login/:loc" component={Login} />
          </Switch>
        </Router>
      </ThemeProvider>
    </SWRConfig>
  </Provider>, document.getElementById('root'),
);

if (String(document.location.href).includes('strongholdpartners.com')) {
  document.location.href = 'https://agent.strongholdweatlhpartners.com';
}
